/**
 * Copyright 2019-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import { Alert } from 'react-bootstrap';

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      hasError: false,
      msg: ''
    };
  }

  componentDidCatch (error/*, info */) {
    // Display fallback UI
    this.setState({ hasError: true, msg: error.message });
    console.error('Catched error:');
    console.error(error.stack);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.state !== this.props.state) {
      this.setState(
        { hasError: false }
      );
    }
  }

  render () {
    if (this.state.hasError) {
      return <Alert variant={'danger'}>
        <Alert.Heading>Error in rendering {this.props.title}</Alert.Heading>
        {this.state.msg}
      </Alert>;
    }
    return this.props.children;
  }
}
